module.exports = __webpack_public_path__ + "img/verification_circle.c9ed8f94.gif";